// Русские переводы. Группируем по странам/разделам, чтобы было видно
// иерархию ключей. Совпадение структуры с `en.ts` гарантировано типом
// `Dictionary` (см. `index.tsx`).
const ru = {
  common: {
    languageRu: 'Русский',
    languageEn: 'English',
    loading: 'Загрузка…',
    cancel: 'Отмена',
    close: 'Закрыть',
    save: 'Сохранить',
    copy: 'Скопировать',
    copied: 'Скопировано',
    email: 'Email',
    phone: 'Телефон',
  },
  toast: {
    errorTitle: 'Ошибка',
    details: 'Подробнее',
    hide: 'Свернуть',
    statusCode: 'Код',
  },
  shell: {
    tabs: {
      monitoring: 'Мониторинг',
      planning: 'Планирование',
      configuration: 'Конфигурация',
      system: 'Система',
    },
    noLocations: 'Локации не назначены',
  },
  sidebar: {
    expand: 'Развернуть',
    collapse: 'Свернуть',
    monitoring: {
      processing: 'Операции',
      transport: 'Транспорт',
      cargo: 'Грузы',
      stats: 'Статистика',
      messagesQueue: 'Очередь сообщений',
    },
    planning: {
      timeslots: 'Таймслоты',
      shipping: 'Графики отгрузки',
      supply: 'Графики поставки',
    },
    configuration: {
      myData: 'Мои данные',
      composition: 'Состав',
      queues: 'Очереди',
      directions: 'Направления',
    },
    system: {
      objects: 'Объекты',
      counterparties: 'Контрагенты',
      users: 'Пользователи',
      integrations: 'Интеграции',
      administration: 'Администрирование',
    },
  },
  profileMenu: {
    aria: 'Меню профиля',
    fallbackTitle: 'Профиль',
    profile: 'Профиль',
    accountManagement: 'Управление аккаунтом',
    contactSupport: 'Связаться с поддержкой',
    logout: 'Выйти',
    roles: {
      account_owner: 'Владелец Account',
      company_admin: 'Администратор',
      configurator: 'Конфигуратор',
      planner: 'Планировщик',
      operator: 'Оператор',
      counterparty: 'Контрагент',
    },
    support: {
      title: 'Связаться с поддержкой',
      description:
        'Опишите, что произошло, и приложите скриншот, если возможно. Мы отвечаем в рабочие часы (Мск, 9:00–19:00).',
      formHint:
        'Форма обратной связи прямо из приложения появится позже — пока пишите/звоните напрямую.',
    },
  },
  locationDropdown: {
    selectLocation: 'Выберите локацию',
    noLocations: 'Локации не назначены',
  },
  sectionShell: {
    accessDenied: '🔒 Доступ ограничен',
    pickLocation: '📍 Выберите локацию',
  },
  profilePage: {
    languageSection: 'Язык интерфейса',
    languageHint: 'Выбор сохраняется только в этом браузере. Синхронизация с профилем — следующим шагом.',
    workspaceSection: 'Рабочая область',
    showOnlyGrantedLabel: 'Только локации с явным доступом',
    showOnlyGrantedHint: 'У вас как у владельца аккаунта по умолчанию виден список всех локаций всех организаций. Включите, чтобы в шапке оставались только те, на которые вам выдан явный доступ (как у обычного оператора). Полезно, если в аккаунте много локаций, а в повседневной работе нужны единицы.',
  },
  roles: {
    ACCOUNT_OWNER: 'Владелец',
    COMPANY_ADMIN: 'Админ организации',
    CONFIGURATOR: 'Администратор объекта',
    PLANNER: 'Координатор',
    OPERATOR: 'Оператор',
    COUNTERPARTY: 'Партнёр',
  },
  loginPage: {
    brandTitle: 'RITM-FLOW',
    brandTagline: 'Система управления логистикой',
    brandHint: 'Управляйте поставками, расписанием и автопарком из единого окна.',
    formTitle: 'Вход в систему',
    formSubtitle: 'Введите логин и пароль для доступа к рабочему столу',
    loginPlaceholder: 'Логин',
    passwordPlaceholder: 'Пароль',
    loginButton: 'Войти',
    loginButtonLoading: 'Входим…',
    errFill: 'Заполните все поля',
    errLogin: 'Ошибка входа',
    errUserInfo: 'Не удалось загрузить данные пользователя',
    errWrongCreds: 'Неверный логин или пароль',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    footer: '© {year} Ritmflow',
    forgotLink: 'Забыли пароль?',
    resetTitle: 'Сброс пароля',
    resetSubtitle:
      'Укажите email или телефон. Если такая учётная запись существует, на неё уйдёт ссылка для сброса.',
    resetPlaceholder: 'Email или телефон',
    resetSubmit: 'Прислать ссылку',
    resetSubmitLoading: 'Отправляю…',
    resetBack: 'Назад ко входу',
    resetNeutralOk:
      'Если такая учётная запись существует, ссылка для сброса пароля будет отправлена.',
  },
  onboardingPage: {
    title: 'Настройка аккаунта',
    welcomeOwner: 'Чтобы начать работать с системой, создайте первую компанию и её локацию. Локация — это место, между которыми возятся грузы (склад, офис, магазин). Адрес и координаты можно дозаполнить позже.',
    welcomeNotOwner: 'В аккаунте пока нет ни одной локации. Дождитесь, пока владелец аккаунта закончит настройку — после этого вы сможете работать с разделами «Мониторинг», «Планирование» и другими.',
    noAccessTitle: 'У вас нет доступа к локациям',
    noAccessHint: 'Попросите администратора аккаунта выдать вам доступ хотя бы к одной локации.',
    ctaCreate: 'Создать компанию и локацию',
    accountInfo: 'Аккаунт: {name}',
  },
  accountPage: {
    accessDeniedTitle: '🔒 Доступ только для владельца Account',
    accessDeniedHint: 'Этот раздел доступен только пользователям с ролью «Владелец Account».',
    accountEyebrow: 'Аккаунт',
    renameTooltip: 'Переименовать аккаунт',
    planBadge: 'тариф: {plan}',
    createdAt: 'создан {date}',
    ownerLabel: 'Владелец',
    transferOwnerLink: 'Передать другому',
    accountSummaryLabel: 'Состав аккаунта',
    statsCompanies: 'Орг.:',
    statsLocations: 'Локаций:',
    statsUsers: 'Польз.:',
    statsCounterparties: 'Контр.:',
    holdingCompanies: 'Организации холдинга',
    addCompanyShort: 'Добавить',
    noCompaniesHint: 'Ещё ни одной организации. Добавьте — она станет основной автоматически.',
    primaryBadge: 'основная',
    status: {
      trial: 'Пробный',
      active: 'Активен',
      suspended: 'Приостановлен',
      closed: 'Закрыт',
    },
    rename: {
      title: 'Переименовать аккаунт',
      nameLabel: 'Новое название',
      saving: 'Сохраняю…',
      errEmpty: 'Название не может быть пустым.',
      errSave: 'Не удалось сохранить',
    },
    addCompany: {
      title: 'Добавить организацию',
      saving: 'Создаю…',
      submit: 'Создать',
      errEmpty: 'Краткое название обязательно.',
      errEmptyLocation: 'Название первой локации обязательно.',
      errCreate: 'Не удалось создать организацию',
      makePrimary: 'Сделать основной',
      primaryWarning: '· текущая основная перестанет быть таковой',
      locationSectionTitle: 'Первая локация',
      locationSectionHint: 'У организации должна быть как минимум одна локация — это место, между которыми возятся грузы. Адрес и координаты можно заполнить позже.',
      fields: {
        displayName: 'Краткое название',
        displayNamePlaceholder: 'Альфа-Логистика',
        country: 'Страна',
        countryPlaceholder: 'RU',
        inn: 'ИНН',
        innPlaceholder: '7707…',
        kpp: 'КПП',
        ogrn: 'ОГРН',
        legalAddress: 'Юридический адрес',
        contactPhone: 'Контактный телефон',
        contactPhonePlaceholder: '+7 …',
        locationName: 'Название локации',
        locationNamePlaceholder: 'Склад «Москва-1»',
        locationKind: 'Тип локации',
        isOperational: 'Операционная локация',
        isOperationalHint: 'Здесь работают наши операторы и есть терминал — будет видна в шапке.',
        isPassiveHint: 'Пассивная адрес-точка для грузопотока — в шапке выбирать её нельзя.',
        firstOperationalRequired: 'Первая локация аккаунта должна быть операционной.',
      },
      kindOptions: {
        OFFICE: 'Офис',
        WAREHOUSE: 'Склад',
        SHOP: 'Магазин',
        PARKING: 'Стоянка',
        LOGISTICS_CENTER: 'Логистический центр',
        SHOPPING_COMPLEX: 'Торговый комплекс',
        CAR_FLEET: 'Автопарк',
        LOGISTICS_COMPLEX: 'Логистический комплекс',
      },
    },
    transfer: {
      title: 'Передача владения аккаунтом',
      description:
        'После передачи вы перестанете быть владельцем — роль изменится на «Админ организации». Доступ к управлению пользователями и интеграциями останется, но передавать аккаунт и закрывать его сможет только новый владелец.',
      noCandidates:
        'В аккаунте нет других активных пользователей, кому можно передать владение. Сначала пригласите кого-то через «Система → Пользователи».',
      newOwnerLabel: 'Новый владелец',
      pickUserOption: '— выберите пользователя —',
      passwordLabel: 'Подтверждение паролем',
      passwordPlaceholder: 'Ваш текущий пароль',
      submit: 'Передать владение',
      submitting: 'Передаю…',
      confirm: 'Передать владение аккаунтом? Эту операцию нельзя отменить.',
      errNoTarget: 'Выберите нового владельца.',
      errNoPassword: 'Подтвердите паролем.',
      errFail: 'Не удалось передать владение',
    },
    modal: {
      closeAria: 'Закрыть',
    },
  },
  queues: {
    addQueue: 'Добавить очередь',
    createTitle: 'Новая очередь',
    deleteConfirm: 'Удалить очередь «{{name}}»?',
    deleteHint: 'Вместе с очередью будут удалены все её расписания и таймслоты.',
    serviceModeLabel: 'Режим обслуживания',
    serviceMode: {
      always_first: 'Всегда первый',
      cyclic: 'Циклично по порядку',
      random: 'Случайно',
      operator: 'Управляется оператором',
    },
    queueType: 'Тип очереди',
    queueTypeOptions: {
      service: 'Обслуживание',
      parking: 'Парковка',
      control: 'Контроль',
    },
    queueColor: 'Цвет',
    queueName: 'Название',
    queueNamePlaceholder: 'Например: Погрузка',
    cargoModesLabel: 'Обслуживаемые типы груза',
    cargoModesHint: 'Если ничего не выбрано — очередь обслуживает любые типы.',
    cargoModesEmpty: 'Справочник типов груза пуст.',
    cargoModesAny: 'Любой тип груза',
    pickColorManually: 'Выбрать цвет вручную',
    createButton: 'Создать',
    nameRequired: 'Название обязательно',
    createError: 'Ошибка при создании очереди',
    selectQueueHint: 'Выберите очередь, чтобы просмотреть её расписание',
    edit: 'Редактировать',
    delete: 'Удалить',
    planDayIntervals: {
      title: 'Спланировать интервалы',
      save: 'Спланировать',
      startTime: 'Время начала дня',
      endTime: 'Время конца дня',
      intervalLabel: 'Интервал для планирования',
      intervalOptions: {
        m30: '30 минут',
        m60: '1 час',
        m90: '1 час 30 минут',
        m120: '2 часа',
        m180: '3 часа',
        m240: '4 часа',
        m360: '6 часов',
        m480: '8 часов',
      },
      lunchToggle: 'Время обеда',
      lunchStart: 'Начало обеда',
      lunchEnd: 'Конец обеда',
      serviceSectionTitle: 'Параметры обслуживания (в минутах)',
      maneuverTime: 'Время маневрирования',
      serviceTime: 'Время обслуживания',
      activeDocks: 'Активных ворот',
      activeDocksHint: 'По умолчанию — число мест, привязанных к очереди ({n}).',
      throughput: 'Пропускная способность (рейсов)',
      throughputAutoBtn: 'авто',
      throughputAutoBtnTitle: 'Вернуть авто-расчёт',
      throughputAutoHint: 'Авто = ⌊{docks} × {minutes} мин ÷ ({maneuver} + {service}) мин⌋ = {result}.',
    },
  },
  /* __I18N_ANCHOR_ACCOUNT_PAGE__ */
  notifications: {
    title: 'Уведомления',
    empty: 'Все спокойно',
    emptyHint: 'Когда появится событие, требующее реакции — оно появится здесь.',
    markAllRead: 'Прочитано всё',
    showResolved: 'Показать обработанные',
    hideResolved: 'Скрыть обработанные',
    resolvedBadge: 'Обработано',
    openSettings: 'Настройки уведомлений',
    bellAria: 'Уведомления',
    scope: {
      active: 'Эта локация',
      all: 'Все мои',
    },
    connection: {
      online: 'Подключено',
      offline: 'Связь потеряна · polling',
    },
    footer: {
      shown: 'Показано {n}',
    },
    types: {
      terminal_pending: {
        label: 'Новый терминал ожидает подтверждения',
        title: 'Новый терминал ожидает подтверждения',
        subtitle: '{terminal_label} · {location_name}',
      },
      driver_message_incoming: {
        label: 'Входящие сообщения от водителей',
        title: 'Сообщение от водителя',
        subtitle: '{driver_name} · {message_type_name}',
      },
      driver_registration: {
        label: 'Регистрация водителя на терминале',
        title: 'Регистрация водителя',
        subtitle: 'ТС {vehicle_number}',
      },
    },
    actions: {
      approve: 'Подтвердить',
      reject: 'Отклонить',
      resolve: 'Готово',
      reply: 'Ответить',
      open: 'Открыть',
      formCruise: 'Сформировать рейс',
    },
    rejectReasonPrompt: 'Причина отказа:',
    errors: {
      approveFail: 'Не удалось подтвердить',
      rejectFail: 'Не удалось отклонить',
      resolveFail: 'Не удалось завершить',
    },
    detail: {
      message: 'Сообщение',
      data: 'Данные',
      noData: 'Дополнительных данных нет.',
    },
    severity: {
      INFO: 'Инфо',
      WARN: 'Внимание',
      URGENT: 'Срочно',
    },
    fields: {
      terminal_label: 'Терминал',
      device_type_name: 'Тип устройства',
      location_name: 'Локация',
      message_type_name: 'Тип сообщения',
      driver_name: 'Водитель',
      vehicle_number: 'Гос. номер ТС',
      phone: 'Телефон',
      counterparty_name: 'Контрагент',
      operation_type_name: 'Операция',
      cargo_mode_name: 'Тип груза',
      unit_name: 'Ед. изм.',
      amount: 'Количество',
    },
    settings: {
      title: 'Уведомления',
      hint: 'Включите типы событий, по которым хотите получать уведомления в колокольчике.',
    },
  },
  /* __I18N_ANCHOR_PROFILE_PAGE_EXT__ */
  /* __I18N_ANCHOR_LANDINGS__ */
  /* __I18N_ANCHOR_PLACEHOLDERS__ */
  /* __I18N_ANCHOR_MODALS__ */
  /* __I18N_ANCHOR_SECTION_HINTS__ */
  shared: {
    locationKind: {
      OFFICE: 'Офис',
      WAREHOUSE: 'Склад',
      SHOP: 'Магазин',
      PARKING: 'Стоянка',
      LOGISTICS_CENTER: 'Логистический центр',
      SHOPPING_COMPLEX: 'Торговый комплекс',
      CAR_FLEET: 'Автопарк',
      LOGISTICS_COMPLEX: 'Логистический комплекс',
    },
    syncTooltip: 'Синхронизировано с глобальной карточкой — редактирование запрещено',
  },
  /* __I18N_ANCHOR_OBJECTS__ */
  objectsPage: {
    loading: 'Загрузка…',
    noLocations: 'У этой компании пока нет локаций.',
    operationalBadge: 'Операционная',
    passiveBadge: 'Пассивная',
    operationalLabel: 'Операционная локация',
    operationalHint: 'Включена для работы операторов: видна в шапке, на ней настраиваются очереди и площадки. Выключите, чтобы превратить локацию в пассивную адрес-точку — она останется в каталоге для грузопотока, но в шапке не появится.',
    lastOperationalBlocked: 'Это последняя операционная локация в аккаунте — выключить её нельзя. Сначала сделайте операционной другую.',
    bailorZonesTitle: 'Поклажедатели здесь',
    bailorZonesHint: 'Контрагенты, от чьего имени мы ведём операции на этой локации: их товар хранится здесь (3PL). Каждая зона зеркалит саму локацию.',
    bailorChip: 'Поклажедатель',
  },
  statsPage: {
    cruisesTitle: 'Статистика рейсов',
    timesTitle: 'Временные показатели',
    totalCount: 'Итого',
    totalAvg: 'Среднее',
    exportExcel: 'Выгрузить в Excel',
    exportError: 'Не удалось сформировать файл',
    viewTable: 'Таблица',
    viewChart: 'График',
    allQueues: 'Все очереди',
    loading: 'Загрузка статистики…',
    empty: 'Нет данных за период.',
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    prevYear: 'Предыдущий год',
    nextYear: 'Следующий год',
    currentMonth: 'Текущий месяц',
    weekend: 'Выходной',
    period: { day: 'День', week: 'Неделя', month: 'Месяц' },
    periodSuffix: { day: 'за день', week: 'за неделю', month: 'за месяц' },
    prevDay: 'Предыдущий день',
    nextDay: 'Следующий день',
    today: 'Сегодня',
    units: { h: 'ч', m: 'м' },
    gateLoadTitle: 'Загруженность ворот',
    gateLoadEmpty: 'Нет очередей с воротами — привяжите ворота к очередям в «Конфигурации».',
    gatesCount: 'ворот: {n}',
    loadTotal: 'За период',
    loadAvg: 'средняя',
    clickHint: 'Нажмите на цифру или столбик — откроется список рейсов',
    colName: 'Название',
    sortHint: 'Сортировать',
    lateToleranceNote: 'Опозданием считается превышение плана больше чем на {n} мин',
    details: {
      tabCruises: 'Рейсы',
      tabHours: 'По часам',
      tabGates: 'Ворота',
      loading: 'Загрузка…',
      error: 'Не удалось загрузить детализацию',
      empty: 'Рейсов нет.',
      closed: 'выходной',
      truncated: 'Показаны первые {shown} из {total}.',
      wholePeriod: 'весь период',
      colCruise: 'Рейс',
      colVehicle: 'ТС',
      colGate: 'Ворота',
      colQueue: 'Очередь',
      colStatus: 'Статус',
      colPlan: 'План',
      colArrival: 'Приезд',
      colBegin: 'Начало',
      colFinish: 'Окончание',
      colLoad: 'Загрузка',
      colBusy: 'Занято / доступно',
      colCruises: 'Рейсов',
      value: {
        served_late: 'Задержка',
        delay: 'Задержка',
        late_arrivals: 'Опоздание',
        lateness: 'Опоздание',
        service: 'Обслуживание',
        waiting: 'Ожидание',
        placement: 'Постановка',
        gate_load: 'Занято',
      },
      hours: { plan: 'План', arrival: 'Приезд', begin: 'Начало обслуживания', finish: 'Окончание' },
    },
    rows: {
      on_time: 'Обслужены вовремя',
      served_late: 'Обслужено с опозданием',
      late_arrivals: 'Обслужено опоздавших',
      cancelled: 'Отменено',
      rescheduled: 'Перенесено',
      service: 'Среднее время обслуживания',
      placement: 'Среднее время постановки на ворота',
      waiting: 'Среднее время ожидания обслуживания',
      delay: 'Среднее время задержки обслуживания',
      lateness: 'Среднее время опоздания',
      gate_load: 'Загруженность ворот',
    },
    count: { delay: 'задерж.', lateness: 'опозд.' },
  },
  /* __I18N_ANCHOR_USERS_INTEGRATIONS_ADMIN__ */
  usersPage: {
    search: 'Поиск по имени, email, телефону, роли…',
    total: 'всего:',
    addUser: 'Добавить пользователя',
    loading: 'Загрузка…',
    emptyAccount: 'В аккаунте пока никого. Добавьте первого пользователя.',
    emptySearch: 'Никто не подходит под поиск.',
    colUser: 'Пользователь',
    colRole: 'Роль',
    colAccess: 'Доступы',
    blocked: 'заблокирован',
    fullAccess: 'полный доступ',
    orgs: 'орг.',
    locs: 'лок.',
    selectHint: 'Выберите пользователя слева…',
    fieldLastName: 'Фамилия',
    fieldFirstName: 'Имя',
    fieldPatronymic: 'Отчество',
    fieldEmail: 'Email',
    fieldPhone: 'Телефон',
    atLeastOneContact: 'Должен остаться хотя бы один контакт: email или телефон.',
    save: 'Сохранить',
    cancel: 'Отменить',
    edit: 'Редактировать',
    block: 'Заблокировать',
    blockConfirm: 'Заблокировать «{name}»? Пользователь не сможет войти в этот аккаунт. Запись сохраняется — повторная активация через редактирование.',
    statusActive: 'Активен',
    statusActiveLower: 'активен',
    accessSection: 'Доступы к организациям и локациям',
    ownerAccessHint: 'Владелец аккаунта — полный доступ ко всем компаниям и локациям по умолчанию. Конкретные гранты ниже служат для информации и журналирования.',
    noGrantsOwner: 'Явных грантов нет — действует «всё разрешено» из роли.',
    noGrantsEmpty: 'Нет ни одного доступа. В режиме просмотра пользователь не увидит данные аккаунта — нужно выдать доступ хотя бы к одной организации.',
    canModify: 'может изменять',
    record: 'запись',
    ownerFullAccessHint: 'Владелец аккаунта имеет доступ ко всему по умолчанию — галочки ограничивают набор только в специфических кейсах.',
    addedAt: 'Добавлен',
    registeredAt: 'Зарегистрирован',
    readOnly: 'чтение',
    readWrite: 'чтение + запись',
    inviteSection: 'Приглашение для входа',
    inviteStatusNone: 'не приглашён',
    inviteStatusPending: 'ссылка выдана, ждёт активации',
    inviteStatusActivated: 'вход активирован',
    inviteStatusExpired: 'срок действия истёк',
    issuedAt: 'выпущено:',
    validUntil: 'действует до',
    accepted: 'принято',
    copyPwdLinkHint: 'Ссылка для смены пароля выпущена — скопируйте сейчас, второй раз показать нельзя',
    copyInviteLinkHint: 'Ссылка-приглашение выпущена — скопируйте сейчас, второй раз показать нельзя',
    copyLink: 'Скопировать ссылку',
    issuePwdLink: 'Выпустить разовую ссылку, по которой пользователь сможет задать новый пароль',
    issuing: 'Выпускаю…',
    sendPwdLink: 'Прислать ссылку на смену пароля',
    issueInviteLink: 'Выпустить ссылку-приглашение — после установки пароля пользователь сможет войти',
    reissueLink: 'Перевыпустить ссылку — предыдущая немедленно перестанет работать',
    invite: 'Пригласить',
    reissue: 'Перевыпустить ссылку',
    modal: {
      title: 'Новый пользователь',
      close: 'Закрыть',
      hint: 'Достаточно одного: email или телефона. Если такой пользователь уже заведён на платформе — он будет добавлен в текущий аккаунт.',
      noCompaniesHint: 'У аккаунта пока нет организаций — добавьте организацию, потом выдайте доступ к ней.',
      primaryBadge: 'основная',
      cancel: 'Отмена',
      create: 'Создать',
      errContact: 'Нужно указать email или телефон',
      creating: 'Создаю…',
    },
  },
  integrationsPage: {
    kindWms: 'WMS — складская',
    kindTms: 'TMS — транспортная',
    kindErp: 'ERP — учётная',
    kindOther: 'Прочое',
    transportHttpIn: 'HTTP — приходит к нам',
    transportHttpOut: 'HTTP — мы запрашиваем',
    transportFile: 'Файловый обмен',
    transportMixed: 'Смешанный',
    entityCargo: 'Груз',
    entityCruise: 'Рейс',
    entityOther: 'Прочее',
    lastActivityNever: 'ещё не было',
    lastActivityNow: 'только что',
    lastActivityHours: '{n} ч назад',
    lastActivityDays: '{n} дн назад',
    loading: 'Загрузка…',
    emptyHint: 'Пока ни одной интеграции. Создайте первую — она получит inbound-токен, по которому внешняя система сможет слать данные.',
    addIntegration: 'Добавить интеграцию',
    selectHint: 'Раскройте интеграцию слева, чтобы увидеть журнал обменов и загрузить файл вручную.',
    modal: {
      title: 'Новая интеграция',
      fieldName: 'Название',
      fieldKind: 'Тип',
      fieldTransport: 'Транспорт',
      fieldDescription: 'Описание',
      namePlaceholder: 'WMS Владивосток',
      descriptionPlaceholder: 'Зачем это, что присылает, кто администрирует на той стороне',
      errCreate: 'Не удалось создать интеграцию',
      errName: 'Название обязательно',
      creating: 'Создаю…',
      create: 'Создать',
    },
    msgCount: 'сообщений:',
    lastError: 'последняя ошибка:',
    createdAt: 'Создана',
    lastExchange: 'Последний обмен',
    inboundSection: 'Inbound-URL и токен',
    copyUrl: 'Скопировать inbound URL',
    copyToken: 'Скопировать только токен',
    tokenHint: 'Токен можно передавать в URL ИЛИ в header X-Integration-Token',
    regenConfirm: 'Перегенерировать токен? Старый сразу перестанет принимать запросы — внешней системе придётся выдать новый.',
    disable: 'Выключить',
    enable: 'Включить',
    disableLabel: 'Выключить интеграцию',
    enableLabel: 'Включить интеграцию',
    ingestModeOn: 'Принимать данные',
    ingestModeOff: 'Только журнал',
    ingestModeOnLabel: 'Включить разбор входящих в рейсы и грузы',
    ingestModeOffLabel: 'Перевести в режим «только журнал» — сохранять сообщения, но не разбирать',
    ingestBadgeOn: 'принимает данные',
    ingestBadgeOff: 'режим журнала',
    deleteConfirm: 'Удалить интеграцию «{name}»? Все её сообщения тоже удалятся.',
    delete: 'Удалить',
    lastErrorSection: 'Последняя ошибка',
    upload: 'Загрузить файл',
    uploading: 'Загружаю…',
    uploaded: 'загружено:',
    logSection: 'Журнал обменов · всего',
    logReceived: 'принято:',
    logErrors: 'ошибок:',
    logEmpty: 'Сообщений пока нет. Когда внешняя система пришлёт что-то на inbound URL или вы загрузите файл вручную — они появятся здесь.',
    statusReceived: 'принято',
    statusProcessed: 'обработано',
    statusError: 'ошибка',
    msgTitle: 'Сообщение #{id}',
    receivedAt: 'Получено:',
    msgFile: 'файл:',
    openOriginal: 'открыть оригинал',
    tabJson: 'JSON',
    tabText: 'Текст',
    tabHeaders: 'Заголовки',
    empty: '(пусто)',
    processingError: 'Ошибка обработки:',
    scheduleError: 'Ошибка автографика:',
    viewAllJournal: 'Весь журнал',
    reprocessUnprocessed: 'Перезапустить необработанные',
    reprocessUnprocessedTitle: 'Повторно обработать принятые и ошибочные грузы и рейсы',
    reprocessAll: 'Перезапустить всё',
    reprocessAllTitle: 'Повторно обработать все записи журнала, включая уже обработанные',
    reprocessAllConfirm: 'Перезапустить весь журнал, включая уже обработанные записи? Все грузы и рейсы будут разобраны заново.',
    reprocessResult: 'Перезапущено: {processed} из {total}',
    reprocessErrorsSuffix: ', ошибок: {failed}',
    reprocessSkippedSuffix: ', пропущено: {skipped}',
    clearJournal: 'Очистить журнал',
    clearJournalTitle: 'Удалить все сообщения журнала обмена без возможности восстановления',
    clearJournalConfirm: 'Удалить ВСЕ {total} сообщений журнала обмена? Действие необратимо. Уже разобранные грузы и рейсы при этом сохранятся — удаляется только сырой журнал.',
    clearing: 'Удаление…',
    clearJournalResult: 'Удалено сообщений: {deleted}',
    journalTitle: 'Журнал обменов — {name}',
    journalFilterStatus: 'Статус',
    journalFilterDirection: 'Направление',
    journalFilterKind: 'Тип данных',
    journalFilterAll: 'Все',
    directionInbound: 'Входящие',
    directionOutbound: 'Исходящие',
    journalShown: 'Показано {n} из {total}',
    journalEmpty: 'Нет сообщений по выбранным фильтрам.',
    loadMore: 'Показать ещё',
    loadingMore: 'Загрузка…',
    targetLocation: 'Целевая локация',
    targetLocationHint: 'Куда писать рейсы и грузы из этой интеграции',
    targetLocationNone: 'Не выбрана',
    targetLocationRequired: 'Включён приём данных, но не выбрана целевая локация — разбор будет падать с ошибкой «не задан location_id». Выберите локацию.',
    autoGraphSection: 'Автосоздание графиков',
    autoGraphHint: 'Создавать плановые точки графика вместе с приходящими рейсами',
    assignSiteIncomeSection: 'Присваивать ворота — приёмка',
    assignSiteIncomeHint: 'Искать ворота по коду SITE и привязывать к рейсу/грузу приёмки. Если выключено — ворота не присваиваются (поле остаётся пустым)',
    assignSiteOutgoingSection: 'Присваивать ворота — отгрузка',
    assignSiteOutgoingHint: 'Искать ворота по коду SITE и привязывать к рейсу/грузу отгрузки. Если выключено — ворота не присваиваются (поле остаётся пустым)',
    allowGateOverlapSection: 'Разрешить наложение на воротах',
    allowGateOverlapHint: 'Несколько рейсов на одни ворота обрабатываются без ошибки «ворота заняты». Включайте, когда источник (WMS) допускает одновременное обслуживание нескольких рейсов на одних воротах',
    gateCodesSection: 'Коды обмена ворот',
    gateCodesHint: 'Код из поля SITE входящих сообщений — по нему разбор находит ворота целевой локации. Код не повторяется в пределах локации',
    gateCodesFilled: 'заполнено {n} из {m}',
    gateCodesEmpty: 'В целевой локации нет ворот («Место погрузки»). Добавьте их в «Конфигурация → Состав»',
    gateCodesPlaceholder: 'Код обмена',
    gateCodesSaveError: 'Не удалось сохранить код',
    finishConfirmedBySection: 'Подтверждение окончания задания',
    finishConfirmedByHint: 'Кто отмечает завершение обслуживания рейса. «Сотрудник локации» — работник склада (у водителя показывается «Ожидание»). «Водитель/экспедитор» — сам отмечает окончание в терминале',
    finishConfirmedByStaff: 'Сотрудник локации',
    finishConfirmedByDriver: 'Водитель / экспедитор',
    reprocess: 'Обработать заново',
    reprocessing: 'Обработка…',
    payload: {
      readableTab: 'Расшифровка',
      empty: '—',
      fieldDocTitle: 'Наименование',
      fieldStatus: 'Статус',
      fieldDtype: 'Тип операции',
      fieldSmode: 'Режим хранения',
      fieldLocFrom: 'Отправитель',
      fieldLocTo: 'Получатель',
      fieldDocId: 'Номер документа',
      fieldDocDate: 'Дата документа',
      fieldDocPriority: 'Приоритет',
      fieldGuid: 'Идентификатор (GUID)',
      fieldVersion: 'Версия',
      fieldSite: 'Площадка',
      fieldTruck: 'Транспорт',
      fieldPlanTime: 'Плановое начало',
      fieldStartTime: 'Начало',
      fieldEndTime: 'Окончание',
      fieldCargoList: 'Грузы',
      cargoItem: 'Груз {n}',
      status10: 'Обслуживается',
      status11: 'Запланирован',
      status12: 'Отменён',
      status16: 'Завершён',
      statusUnknown: 'Статус {code}',
      dtypeIncome: 'Приёмка',
      dtypeSale: 'Отгрузка',
      smodeDry: 'Сухой',
      smodeFrozen: 'Заморозка',
      smodeChilled: 'Охлаждённый',
    },
  },
  administrationPage: {
    siteTemplates: 'Шаблоны площадок',
    detailSection: 'Детали',
    colName: 'Название',
    colType: 'Тип',
    colStatus: 'Статус',
    scopeGlobal: '🌍 Глобальный',
    scopeAccount: '🏢 Аккаунтовый',
    descriptionSection: 'Описание',
    structureSection: 'Структура',
    selectHint: 'Выберите шаблон',
  },
  /* __I18N_ANCHOR_COUNTERPARTIES__ */
  counterpartiesPage: {
    search: 'Поиск по названию, ИНН, коду…',
    filterAll: 'Все',
    filterSupplier: 'Поставщики',
    filterReceiver: 'Получатели',
    filterPartner: 'Партнёры',
    filterBailor: 'Поклажедатели',
    filterOwn: 'Свои',
    recentlyChanged: 'Недавно изменённые',
    recentlyChangedHint: 'Оставить только контрагентов, изменённых за выбранное окно (3 или 7 дней), для быстрой проверки на дубли',
    days: 'дн',
    innDuplicates: 'Совпадений ИНН:',
    innFilterActive: 'Фильтр активен — показываем только контрагентов с дублями ИНН. Кликните, чтобы снять.',
    innFilterHint: 'Кликните, чтобы оставить только контрагентов с совпадающим ИНН и проверить пары на слияние.',
    loading: 'Загрузка…',
    emptyCompany: 'У компании пока нет контрагентов.',
    emptySearch: 'Никто не подходит под текущий поиск/фильтр.',
    showMasterTooltip: 'Показать связь с мастером (зеркало)',
    hideMasterTooltip: 'Скрыть связь с мастером (зеркало)',
    colName: 'Название',
    colLocations: 'Локации',
    syncGlobal: 'Данные глобального справочника',
    syncLocal: 'Данные справочника Компании',
    mirrorOf: 'Зеркало контрагента «{name}»',
    blocked: 'заблокирован',
    blockedHint: 'Запрещён к использованию — не появляется в выпадающих списках выбора',
    innDuplicateHint: 'ИНН {inn} совпадает с: {names}. Возможный дубль — рассмотрите связку «Синхронизировать с другим контрагентом аккаунта».',
    selectHint: 'Выберите контрагента, чтобы увидеть его данные.',
    detail: {
      fieldDisplayName: 'Краткое название',
      fieldLegalName: 'Полное юридическое наименование',
      fieldLastName: 'Фамилия',
      fieldFirstName: 'Имя',
      fieldInn: 'ИНН',
      fieldCode: 'Внутр. код',
      fieldNotes: 'Заметки',
      locationsSection: 'Локации',
      locationsCount: '({count})',
      noLocations: 'У контрагента нет локаций. Грузы возятся между Локациями — добавьте хотя бы одну.',
      createdAt: 'Создан',
      updatedAt: 'Обновлён',
      isBlocked: 'Запрещён к использованию',
      blockedDescription: 'Контрагент скрыт из выпадающих списков выбора в Cruise/Cargo. Соглашение с ним приостановлено — но карточка сохранена для истории.',
      isAvailable: 'Доступен для использования',
      availableHint: 'Снимите галочку, чтобы скрыть контрагента из выпадающих списков Cruise/Cargo, не удаляя карточку.',
      save: 'Сохранить',
      cancel: 'Отменить',
      edit: 'Редактировать',
      uploadLogo: 'Загрузить логотип',
      deleteLogo: 'Удалить логотип',
      loading: 'Загрузка…',
      master: 'Мастер',
      errSave: 'Не удалось сохранить',
    },
    localLocation: {
      backToCounterparty: '← К контрагенту',
      title: 'Локация контрагента',
      synced: 'Синхронизирована',
      fieldFullName: 'Полное название',
      fieldKind: 'Тип объекта',
      fieldTimezone: 'Часовой пояс',
      fieldAddress: 'Адрес',
      fieldPhone: 'Контактный телефон',
      fieldCoords: 'Координаты',
      fieldId: 'ID',
      fieldCode: 'Внутр. код',
      fieldDescription: 'Описание',
      fieldWorkMode: 'Режим работы',
      fieldPhoto: 'Фото',
      fieldDrivingScheme: 'Схема проезда',
      kindWarehouse: 'Склад',
      kindTerminal: 'Терминал',
      kindDock: 'Dok / погрузочный пункт',
      kindOffice: 'Офис',
      kindOther: 'Другое',
      purposeSection: 'Назначение локации',
      purposeNone: '— не задан —',
      purposeSupplier: 'Поставщик',
      purposeReceiver: 'Получатель',
      purposeSite: 'Площадка',
      defaultTimezone: 'Europe/Moscow',
      noPhoto: 'нет фото',
      noDrivingScheme: 'нет схемы',
      upload: 'Загрузить',
      replace: 'Заменить',
      delete: 'Удалить',
      loading: 'Загрузка…',
      file: 'Файл',
      workModeEditNotSupported: 'Редактирование режима работы в этой версии не поддерживается.',
      createdAt: 'Создана',
      updatedAt: 'Обновлена',
      isBlocked: 'Запрещена к использованию',
      blockedDescription: 'Локация скрыта из выпадающих списков выбора в Cruise/Cargo.',
      isAvailable: 'Доступна для использования',
      availableHint: 'Снимите галочку, чтобы скрыть локацию из выпадающих списков Cruise/Cargo, не удаляя карточку.',
      syncGlobal: 'Данные глобального справочника',
      syncLocal: 'Данные справочника Компании',
      master: 'Мастер',
      globalLocation: 'Глобальная локация',
      workModeGlobal: 'Режим работы (глоб.)',
      photoGlobal: 'Фото (глоб.)',
      drivingSchemeGlobal: 'Схема проезда (глоб.)',
      unlinkFromLocal: 'Отвязать «{display_name}» от локации «{name}»? Локальные значения останутся, но синхронизация будет отключена.',
      unlinkFromGlobal: 'Отвязать «{display_name}» от глобальной локации? Локальные значения останутся, но синхронизация будет отключена.',
    },
    syncControls: {
      sectionTitle: 'Управление синхронизацией',
      save: 'Сохранить',
      cancel: 'Отменить',
      manageAria: 'Управлять синхронизацией',
      manageTitle: 'Изменить настройки, обновить или отвязать',
      autoSyncLabel: 'Автоматически обновлять из глобальной',
      autoSyncOn: 'включена',
      autoSyncOff: 'выключена',
      syncedFields: 'Синхронизируемые поля:',
      noSyncedFields: 'Поля синхронизации не выбраны — все значения редактируются локально.',
      fieldsSection: 'Поля, ведомые из глобальной карточки',
      fieldsHint: 'Отмеченные поля становятся read-only в локальной карточке и при включённой автосинхронизации обновляются из глобальной.',
      disabledByOwner: 'запрещена владельцем',
      disabledByOwnerTitle: 'Владелец глобальной карточки не разрешает синхронизацию',
      pullNow: 'Обновить сейчас',
      pulling: 'Обновляю…',
      pullTitle: 'Однократно подтянуть значения отмеченных полей из глобальной карточки',
      pullDisabledTitle: 'Владелец глобальной карточки закрыл доступ к данным',
      unlink: 'Отвязать',
      unlinking: 'Отвязываю…',
      unlinkTitle: 'Отвязать от глобальной карточки и сделать карточку полностью локальной',
      errSaveSync: 'Не удалось сохранить настройки синхронизации',
      errPull: 'Не удалось обновить из глобальной карточки',
      errUnlink: 'Не удалось отвязать',
      errAutoSyncDisallowed: 'Владелец глобальной карточки не разрешил синхронизацию — авто-режим включить нельзя.',
      cpFieldLabels: {
        display_name: 'Краткое название',
        legal_name: 'Юридическое название',
        inn: 'ИНН',
        logo: 'Логотип',
      },
      llFieldLabels: {
        display_name: 'Краткое название',
        official_name: 'Полное название',
        kind: 'Тип',
        address: 'Адрес',
        description: 'Описание',
        contact_phone: 'Контактный телефон',
        latitude: 'Широта',
        longitude: 'Долгота',
        timezone: 'Часовой пояс',
        photo: 'Фото',
        ride_scheme: 'Схема проезда',
        operating_hours: 'Режим работы',
      },
    },
  },
  /* __I18N_ANCHOR_CONFIGURATION__ */
  planningPage: {
    common: {
      search: 'Поиск по графикам и контрагентам',
      total: 'Всего',
      loading: 'Загрузка…',
      detailLoading: 'Загружаю детали…',
      selectHint: 'Выберите график слева, чтобы посмотреть детали.',
      prevWeek: 'Предыдущая неделя',
      nextWeek: 'Следующая неделя',
      prevMonth: 'Предыдущий месяц',
      nextMonth: 'Следующий месяц',
      today: 'Сегодня',
      disabled: 'Отключён',
      scheduleDisabledTitle: 'График отключён',
    },
    create: {
      button: 'График',
      titleInbound: 'Новый график поставки',
      titleOutbound: 'Новый график отгрузки',
      name: 'Название',
      namePlaceholder: 'Например: Поставка · Поставщик (склад)',
      targetLocation: 'По локации',
      targetDirection: 'По направлению',
      partnerLocation: 'Локация партнёра',
      direction: 'Направление',
      choosePlaceholder: 'Выберите…',
      km: 'км',
      min: 'мин',
      descriptionLabel: 'Описание',
      submit: 'Сохранить',
      created: 'График создан',
      saved: 'График сохранён',
      deleted: 'График удалён',
      delete: 'Удалить график',
      editTitle: 'Редактировать график',
      edit: 'Редактировать график',
      error: 'Не удалось сохранить график',
    },
    point: {
      addButton: 'Точка',
      createTitle: 'Новая точка графика',
      editTitle: 'Точка графика',
      overrideTitle: 'Исключение в серии',
      date: 'Дата',
      unit: 'Единица',
      notes: 'Заметки',
      activeTitle: 'Активна',
      activeDesc: 'Неактивные точки не учитываются в планировании',
      delete: 'Удалить точку',
      created: 'Точка добавлена',
      saved: 'Точка сохранена',
      deleted: 'Точка удалена',
      skipped: 'Точка отменена на эту дату',
      skipThisDay: 'Отменить только эту дату',
      skipThisDayHint: 'Создаёт исключение в серии: на эту дату точки не будет.',
      convertToWeekly: 'Сделать еженедельной',
      convertToWeeklyTitle: 'Перевести в еженедельную серию',
      convertToWeeklyHint: 'Текущая дата станет стартовой; точка будет повторяться каждую неделю в этот день.',
      convertedToWeekly: 'Точка переведена в еженедельную',
      convertBlockedByWeekly: 'На этот день недели уже есть еженедельная серия — нельзя сделать ещё одну.',
      directionPointHint: 'Это точка графика направления — нужно указать только плановое время начала. Время операций и манёвра суммируется по подвязанным точкам партнёров.',
      startTimeSourceLabel: 'Время начала',
      directionPickerLabel: 'Направление',
      noDirectionsWarn: 'Нет подходящих направлений: у партнёрской локации нет привязанных направлений с активным графиком на этой локации.',
      restoreSeries: 'Вернуть к серии',
      restoredFromOverride: 'Возвращено к серии',
      overrideBadgeModified: 'Переопределено',
      overrideBadgeSkipped: 'Отменено',
      scopeLabel: 'Применить изменения',
      scopeSeries: 'Серия',
      scopeThisDay: 'Только {date}',
      scopeHintSeries: 'Изменения применяются ко всем неделям серии.',
      scopeHintThisDay: 'Изменения применяются только к этой дате (создаётся исключение).',
      error: 'Не удалось сохранить точку',
      weeklyExistsHint: 'В этот день уже есть еженедельная поставка — можно добавить только разовую (она будет идти вместе с еженедельной).',
      seriesNote: 'Еженедельная точка повторяется каждую неделю. Изменения применяются ко всей серии.',
      maneuverPlaceholder: 'Авто (из очереди)',
      maneuverHint: 'Пусто — берём из настроек интервала очереди.',
      dayPointsTitle: 'Точки выбранного дня',
      cruiseCreationSourceLabel: 'Источник создания рейса',
      daysAheadPlaceholder: 'N',
      daysAheadUnit: 'дн.',
      daysAheadShort: 'за {n} дн.',
    },
    startTimeSource: {
      PLANNED_IN_TS: 'Планируется в ТС',
      PLANNED_IN_TS_hint: 'Стартовое значение; при работе с таймслотами точку можно двигать.',
      ASSIGNED: 'Назначить',
      ASSIGNED_hint: 'Точка жёстко закреплена за временем — в таймслотах не двигается.',
      BY_DIRECTION: 'По направлению',
      BY_DIRECTION_hint: 'Время начала наследуется из точки графика выбранного направления.',
    },
    serviceSource: {
      QUEUE_DEFAULT: 'Из настроек очереди',
      QUEUE_DEFAULT_hint: 'Время операции берётся из интервала расписания очереди по плановому времени.',
      MANUAL: 'Указать явно',
      MANUAL_hint: 'Используется введённое значение времени операции (поле ниже обязательно).',
      VOLUME_BASED: 'По объёму груза',
      VOLUME_BASED_hint: 'amount × «время на единицу» из настроек очереди. Если не настроено — fallback на дефолт очереди.',
      STATISTICS: 'По статистике рейсов',
      STATISTICS_hint: 'Среднее по последним 5 завершённым рейсам этого графика. Если фактов нет — fallback на дефолт очереди.',
      DEPENDENTS_SUM: 'Расчётное (по подвязанным)',
      DEPENDENTS_SUM_hint: 'Сумма времени операций и манёвра по всем точкам партнёров, подвязанным к этому направлению на эту дату.',
    },
    cruiseCreationSource: {
      OPERATOR: 'Оператор',
      OPERATOR_hint: 'Рейс под точку создаёт оператор вручную из списка точек графика.',
      INTEGRATION: 'Интеграция',
      INTEGRATION_hint: 'Рейс приходит из внешней системы (заявка контрагента через интеграцию).',
      BY_SCHEDULE: 'По графику',
      BY_SCHEDULE_hint: 'Рейс создаётся автоматически за указанное число календарных дней до даты точки.',
    },
    filters: {
      allCargoModes: 'Все типы груза',
      allQueues: 'Все очереди',
      targetType: 'Тип цели',
      targetAll: 'Все типы',
      targetLocation: 'По локации',
      targetDirection: 'По направлению',
      activity: 'Активность',
      activityAll: 'Все графики',
      activityActive: 'Только активные',
      activityInactive: 'Только отключённые',
    },
    detail: {
      routeBlock: 'Маршрут и параметры',
      weekTitle: 'График недели',
      weekHint: 'Кружок — есть активная точка. Кликните, чтобы увидеть детали дня.',
      queue: 'Очередь',
      priority: 'Приоритет',
      cargoMode: 'Тип груза',
      distance: 'Расстояние',
      transitTime: 'Время в пути',
      inn: 'ИНН',
      noPointsDay: 'В этот день плановых точек нет.',
      typeWeekly: 'Еженедельная',
      typeOneOff: 'Разовая',
      pointDisabled: 'отключена',
      amount: 'Количество',
      plannedStart: 'План. начало',
      serviceMinutes: 'Обслуживание',
      maneuverMinutes: 'Манёвр',
      serviceSource: 'Расчётное время операции',
      plannedStartTimeBlock: 'Планируемое время начала',
      serviceTimeBlock: 'Время операций',
      expectedAmount: 'Предполагаемое количество',
      startTimeSourceShort: 'Как устанавливается',
      cruiseLinkChip: 'Рейс',
      cruiseLinkTitle: 'Связан с рейсом',
      dependentsCount: 'по {n} подвязанным точкам партнёров',
      cruisesCountBlock: 'Примерное количество рейсов',
    },
    supply: {
      listTitle: 'Графики поставки',
      emptyTitle: 'Нет графиков поставки',
      emptyHint: 'Создайте первый график, чтобы планировать приёмку грузов от контрагентов.',
    },
    shipping: {
      listTitle: 'Графики отгрузки',
      emptyTitle: 'Нет графиков отгрузки',
      emptyHint: 'Создайте первый график, чтобы планировать отгрузку клиентам и по направлениям.',
    },
    weekday: {
      mon: 'Пн', tue: 'Вт', wed: 'Ср', thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Вс',
    },
    weekStrip: {
      hasPlan: 'план',
    },
    copy: {
      button: 'Скопировать график',
      title: 'Скопировать график в…',
      searchPlaceholder: 'Поиск графика по названию или контрагенту',
      directionFilterLabel: 'Направление',
      directionFilterAll: 'Все направления',
      emptyList: 'Нет других графиков для копирования.',
      confirmWarn: 'У выбранных графиков будут заменены еженедельные точки тех же дней недели. Связанные исключения (OVERRIDE) удалятся.',
      submit: 'Скопировать в {n}',
      submitConfirm: 'Подтвердить замену',
      successToast: 'Скопировано в {targets} графиков: {copied} точек, заменено {overwritten}',
      errorToast: 'Не удалось скопировать график',
    },
    timeslots: {
      loadingQueues: 'Загружаю очереди…',
      loadingBoard: 'Загрузка доски…',
      noQueues: 'Очередей нет',
      pickQueueTitle: 'Выберите очередь',
      pickQueueHint: 'У текущей локации нет очередей. Добавьте очередь в Конфигурации, чтобы планировать таймслоты.',
      noScheduleTitle: 'Расписание не задано',
      noScheduleHint: 'У выбранной очереди нет активного расписания на эту неделю. Создайте его в Конфигурации.',
      openQueuesCta: 'Открыть очереди',
      slotFree: 'свободно',
      slotCapacityTitle: 'Занято {occupied} из {capacity}',
      unallocatedTitle: 'Не распределено',
      unallocatedEmpty: 'Все точки графиков распределены по слотам',
      unallocatedDragHint: 'Drag&drop в слот — следующая итерация',
      dayNonWorking: 'Нерабочий день',
      dayNoTemplate: 'Нет активного расписания',
      dayNoTemplateShort: 'Нет расписания',
      dayNoIntervals: 'Нет интервалов',
      dayWeekend: 'Выходной',
      dayAllAllocated: 'Распределены',
      dayUnallocated: '{count} не распр.',
      dayUnallocatedTitle: 'Не распределено точек: {count}',
      directionInbound: 'Поставка',
      directionOutbound: 'Отгрузка',
      queueType: {
        service: 'Обслуживание',
        parking: 'Парковка',
        control: 'Контроль',
      },
      summary: {
        totalSlots: 'всего слотов',
        empty: 'свободно',
        occupied: 'занято',
        full: 'полностью',
        over: 'перегруз',
        unallocated: 'не распределено',
      },
      detailTitle: 'Детали таймслота',
      detailEmptyTitle: 'Слот не выбран',
      detailEmptyHint: 'Кликните по слоту в сетке, чтобы увидеть детали.',
      detail: {
        occupiedLabel: 'занято',
        occupancyPctLabel: 'загрузка',
        capacityLabel: 'вместимость',
        overbookWarn: 'Слот перегружен — точек больше, чем мест.',
        paramsLabel: 'Параметры слота',
        pointsLabel: 'Графики',
        pointsEmpty: 'В этом слоте пока ничего не запланировано.',
        params: {
          active_docks: 'Активных мест',
          maneuver_time_sec: 'Манёвр',
          service_time_sec: 'Обслуживание',
          parking_spots: 'Парковочных мест',
          average_stay_sec: 'Средняя стоянка',
          inspectors: 'Инспекторов',
          inspection_time_sec: 'Длительность контроля',
        },
        category: {
          inbound: 'Поставка',
          inbound_hint: 'График поставки от партнёра.',
          outboundDirection: 'Направление',
          outboundDirection_hint: 'График отгрузки по направлению — сборный рейс под несколько партнёров.',
          outboundLocation: 'Отгрузка',
          outboundLocation_hint: 'График отгрузки конкретному партнёру (время задано в этой точке, не наследуется от направления).',
        },
        loadShort: 'Обсл {service} · Манёвр {maneuver} мин',
        byCategoryTitle: 'Время по категориям',
        byCategory: {
          serviceInbound: 'Поставка',
          serviceDirection: 'Направление',
          serviceOutbound: 'Отгрузка',
          maneuverTotal: 'Манёвр (всего)',
        },
      },
      moveError: 'Не удалось переместить точку',
    },
  },
  configurationPage: {
    myData: {
      loading: 'Загрузка…',
      loadError: 'Не удалось загрузить данные объекта.',
      objectSection: 'Объект',
      fieldType: 'Тип',
      fieldTimezone: 'Часовой пояс',
      fieldOrg: 'Организация',
      statsUsers: 'пользователей:',
      statsVehicles: 'транспорта:',
      statsDevices: 'устройств:',
      usersSection: 'Пользователи объекта',
      noUsers: 'Нет пользователей с явным доступом к этому объекту.',
      accessOwner: 'владелец',
      accessExplicit: 'явно',
      accessInherited: 'унаследовано',
      vehiclesSection: 'Транспорт',
      noVehicles: 'Транспорт не привязан к этой локации.',
      hasTrailer: 'прицеп',
      vehicleActive: 'активен',
      vehicleOff: 'выкл.',
      devicesSection: 'Устройства',
      noDevices: 'Общих устройств, привязанных к локации, пока нет.',
      devicesPlaceholder: 'Раздел «Система → Устройства» в разработке',
      fieldCarrier: 'Перевозчик',
      fieldDriver: 'Водитель',
      fieldBrand: 'Марка',
      fieldCapacity: 'Грузоподъёмность',
      fieldTrailer: 'Прицеп',
      yes: 'да',
      no: 'нет',
      vehiclesEditHint: 'Полное редактирование появится в разделе «Система → Транспорт»',
      lastActivity: 'Последняя активность',
      devicesEditHint: 'Полное редактирование появится в разделе «Система → Устройства»',
      openInUsers: 'Открыть в «Системе → Пользователи»',
      ownerFullAccess: 'Владелец аккаунта — полный доступ ко всем объектам по умолчанию.',
      explicitGrant: 'Явный грант LocationAccess на этот объект.',
      inheritedGrant: 'Доступ унаследован из CompanyAccess (без явного LocationAccess сужения).',
      readOnly: 'только чтение',
      readWrite: 'чтение + запись',
    },
    directions: {
      title: 'Направления',
      empty: 'Нет направлений. Создайте первое.',
      createButton: 'Новое направление',
      createModal: {
        title: 'Создать направление',
        createButton: 'Создать',
      },
      fields: {
        name: 'Наименование',
        code: 'Код',
        description: 'Описание',
        active: 'Активно',
        params: 'Параметры',
        avgDistanceKm: 'Среднее расстояние до объекта, км',
        avgTravelTimeMin: 'Среднее время в пути до объекта, мин',
        avgInternalDistanceKm: 'Среднее расстояние между объектами, км',
        avgInternalTravelTimeMin: 'Среднее время между объектами, мин',
      },
      members: {
        title: 'Объекты направления',
        empty: 'Нет объектов. Добавьте локации контрагентов.',
        addButton: 'Добавить объект',
        searchPlaceholder: 'Поиск по контрагенту или адресу',
      },
      deleteConfirm: 'Удалить направление «{{name}}»?',
    },
  },
  monitoring: {
    cargo: {
      title: 'Грузы',
      shown: 'Показано {n} из {total}',
      loadMore: 'Показать ещё',
      loadingMore: 'Загрузка…',
      searchPlaceholder: 'Поиск: документ, локация, контрагент, GUID',
      empty: 'Грузов нет. Запустите `python manage.py seed_demo_cargo` для демо-данных.',
      bailorLabel: 'Поклажедатель',
      filter: {
        all: 'Все',
        noCruise: 'Без рейса',
        openCruise: 'С активным рейсом',
      },
      col: {
        document: 'Документ',
        partners: 'Отправитель / Получатель',
        mode: 'Режим / кол-во',
        operation: 'Операция / план',
        cruise: 'Рейс',
        created: 'Создан',
      },
    },
    transport: {
      searchPlaceholder: 'Поиск: ТС, водитель, рейс, GUID',
      countSuffix: 'Всего: {n}',
      columnEmpty: 'Пусто',
      typeFilter: {
        label: 'Тип транспорта',
        all: 'Все типы',
      },
      queueFilter: {
        label: 'Очередь обслуживания',
        all: 'Все очереди',
      },
      vehicleType: {
        car: 'Автомобиль',
        trailer: 'Прицеп',
        railcar: 'Вагон',
        airplane: 'Самолёт',
        ship: 'Судно',
      },
      contact: {
        terminal: 'Связь через приложение водителя',
        phone: 'Связь через телефонного бота',
      },
      columns: {
        expected: 'Ожидается',
        waiting: 'Ожидают',
        serving: 'Обслуживаются',
        leaving: 'Убывают',
      },
      time: {
        plan: 'по плану',
        arrived: 'прибыл',
        begun: 'начато',
        finished: 'завершено',
      },
    },
    processing: {
      searchPlaceholder: 'Поиск: рейс, ТС, водитель, GUID',
      filterAll: 'Все',
      shown: 'показано {n} из {total}',
      loadMore: 'Показать ещё',
      loadingMore: 'Загрузка…',
      structureLabel: 'Структура локации',
      structureAll: 'Вся локация',
      statusFilter: {
        label: 'Статус рейсов',
        active: 'Незавершённые',
        done: 'Завершённые',
        cancelled: 'Отменённые',
        all: 'Все',
      },
      gates: {
        scrollLeft: 'Прокрутить ворота влево',
        scrollRight: 'Прокрутить ворота вправо',
        free: 'Свободно',
        inactive: 'Неактивны',
        emptyAll: 'Мест погрузки нет.',
        emptyFiltered: 'Мест погрузки нет в выбранной очереди.',
        openCruise: 'Открыть рейс',
        byDriverTerminal: 'Терминал водителя',
      },
      planned: {
        empty: 'Нет точек рейса в этой локации.',
        col: {
          name: 'Название · Операция · Статус',
          cargo: 'Груз',
          priority: 'Очередь · Место обслуживания',
          transport: 'Транспорт',
          plan: 'План',
          fact: 'Факт',
        },
        overflow: 'Нет мест',
        overflowHint: 'Нет свободных ворот и мест на парковке — ТС ожидает у въезда.',
      },
      panel: {
        closeAll: 'Закрыть панель',
        cp: {
          title: 'Точка рейса',
          sectionTrip: 'Рейс',
          tabCargo: 'Груз',
          tabRoute: 'Маршрут',
          cargos: 'Грузы',
          tasks: 'Задания',
          fields: {
            cruise: 'Рейс',
            vehicle: 'ТС',
            driver: 'Водитель',
            mode: 'Режим',
            site: 'Место',
            plan: 'План',
            begin: 'Начато',
            finish: 'Завершено',
          },
          sectionCargo: 'Груз',
          sectionRoute: 'Маршрут',
          sectionCruise: 'Рейс',
          f: {
            name: 'Название точки',
            order: '№ по маршруту',
            status: 'Статус',
            location: 'Место обслуживания',
            parking: 'Место на парковке',
            operation: 'Тип операции',
            priority: 'Приоритет',
            queue: 'Очередь',
            vehicle: 'Номер ТС',
            driver: 'Водитель',
            boundLocation: 'Локация привязки',
            from: 'Откуда',
            to: 'Куда',
            planBegin: 'Плановое начало',
            factArrival: 'Факт. прибытие',
            factBegin: 'Факт. начало',
            factFinish: 'Факт. окончание',
          },
          cargo: {
            empty: 'Нет грузов у этой точки.',
            which: 'Груз',
            amount: 'Количество',
            from: 'От кого',
            to: 'Кому',
            queue: 'Очередь',
          },
          route: {
            empty: 'Нет точек в этом рейсе.',
            load: 'Погрузка',
            unload: 'Отгрузка',
            current: 'Текущая',
            open: 'Открыть точку рейса',
          },
          cruise: {
            empty: 'Нет точек в этом рейсе.',
            current: 'Текущая',
            open: 'Открыть точку рейса',
            gate: 'Ворота',
            parking: 'Парковка',
            queue: 'Очередь',
            vehicle: 'ТС',
            driver: 'Водитель',
            cargo: 'Груз',
            plan: 'План',
            arrival: 'Прибытие',
            begin: 'Начато',
            finish: 'Завершено',
            noTimes: 'Обслуживание ещё не начато',
          },
          transition: {
            title: 'Сменить статус',
            none: 'Нет доступных переходов из текущего статуса.',
            ok: 'Статус: {status}.',
            err: {
              default: 'Не удалось сменить статус.',
              not_in_matrix: 'Переход недопустим для этого статуса.',
              terminal_status: 'Сущность в терминальном статусе — переходы недоступны.',
              gate_occupied: 'Ворота уже заняты.',
              no_gate_sent_to_parking: 'Нет свободных ворот в очереди обслуживания — ТС отправлено на парковку.',
              no_gate_wait: 'Нет свободных ворот — ожидайте.',
              no_gate_no_parking: 'Нет свободных ворот и мест на парковке — ТС ожидает у въезда.',
              no_parking_spot: 'Нет свободных мест на парковке.',
              required_for_info: 'Не задан номер ТС — рейс не может перейти в активный статус.',
              executor_required: 'Назначьте исполнителя задания.',
              reason_required: 'Для этого статуса нужна причина.',
              reason_mismatch: 'Причина не соответствует целевому статусу.',
              reschedule_required: 'Укажите рейс, на который переносится.',
              out_of_scope: 'Статус не применим к этой сущности.',
              status_not_seeded: 'Статус отсутствует в справочнике.',
            },
          },
          reason: {
            title: 'Выбор причины · {status}',
            empty: 'Нет доступных причин для этого статуса.',
            apply: 'Применить',
          },
          assign: {
            title: 'Назначение машины',
            none: 'Машина не назначена',
            assignBtn: 'Назначить машину',
            changeBtn: 'Заменить',
            removeBtn: 'Снять',
            searchPlaceholder: 'Поиск по номеру или марке…',
            empty: 'Машины не найдены.',
            createNew: 'Новое ТС',
            lockedInService: 'Рейс в обслуживании — машину изменить нельзя.',
            notifiedYes: 'Уведомление отправлено водителю на терминал.',
            notifiedAlready: 'Водитель уже уведомлён об этом рейсе.',
            notifiedNo: 'Активный терминал водителя не найден — уведомление не отправлено.',
            ok: 'Машина назначена.',
            removed: 'Машина снята.',
            err: 'Не удалось выполнить действие.',
          },
          worker: {
            title: 'Назначить работнику',
            assignBtn: 'Назначить',
            pick: 'Выберите работника…',
            noWorkers: 'Нет подходящих работников по профилю.',
            ok: 'Задача назначена.',
            err: 'Не удалось назначить задачу.',
            notifiedYes: 'Уведомление отправлено на терминал работника.',
            notifiedAlready: 'Работник уже уведомлён об этой задаче.',
            notifiedNo: 'Работник не в смене — уведомление не отправлено.',
          },
          truckModal: {
            title: 'Новое транспортное средство',
            number: 'Гос. номер',
            numberPlaceholder: 'А123ВС77',
            brand: 'Марка',
            vehicleType: 'Тип ТС',
            model: 'Модель',
            modelPlaceholder: 'KAMAZ-6520',
            create: 'Создать',
            err: 'Не удалось создать ТС.',
          },
        },
        task: {
          title: 'Задание',
          mainTaskBadge: 'Главная',
          fields: {
            type: 'Тип',
            site: 'Место',
            cruise: 'Рейс',
            created: 'Создано',
            assigned: 'Назначено',
            begin: 'Начало',
            finished: 'Завершено',
            user: 'Исполнитель',
            author: 'Автор',
            source: 'Источник',
          },
        },
      },
    },
  },
}

export default ru
